module.exports = __webpack_public_path__ + "static/media/Vitual-Private-Cloud.db15e317.svg";